import SignUpBackButton from './SignUpBackButton'

export default SignUpBackButton
